import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import React from 'react';
import DateWithHover from '../../timestamps/date_with_hover';

export default function ActivityTable({ activities, vaultIds }) {
  function nameColumn(activity) {
    if (activity.associatedProjectLeadId) {
      return (
        <Link to={`/project_leads/${activity.associatedProjectLeadId}`}>
          {activity.performedBy}
        </Link>
      );
    }

    return activity.performedBy;
  }

  return (
    <div className="table-container" name="vault-activities-table">
      <table className="bo-search-results bordered table-hover table">
        <thead>
          <tr>
            <th>Performed By</th>
            <th>Performed At</th>
            <th>Activity</th>
            {vaultIds.length !== 1 && <th>Sale or Lease</th>}
          </tr>
        </thead>
        <tbody>
          {activities.map(activity => (
            <tr key={`activity-row-${activity.id}`} name="activity-row">
              <td>
                {nameColumn(activity)}
              </td>
              <td><DateWithHover timestamp={activity.performedAt}/></td>
              <td>{activity.type}</td>
              {vaultIds.length !== 1 && <td>{activity.saleOrLease}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

ActivityTable.propTypes = {
  activities: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    performedAt: PropTypes.string.isRequired,
    performedBy: PropTypes.string,
    type: PropTypes.string.isRequired,
    associatedProjectLeadId: PropTypes.number
  })).isRequired,
  vaultIds: PropTypes.array.isRequired,
};
